export const state = {
    isLoaded: false,
    marketTest: {
        id: '',
        fields: []
    }
};